import { setLocationWarningStorageRecord as setLocationWarningStorageRecordHelper } from '../../../actions';
import { type LocationSearchMachineAction } from '../../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const setLocationWarningStorageRecord: LocationSearchMachineAction = ({ context }) => {
  setLocationWarningStorageRecordHelper(context.activeLocation);
};
